import FooterActions from './FooterActions';
export default FooterActions;
